export enum DonationPricingOption {
  Option1 = "5, 10, 25, 50, 100, Custom",
  Option2 = "10, 25, 50, 100, 250, Custom",
  Option3 = "20, 50, 100, 200, 500, Custom",
  Option4 = "100, 250, 500, 1,000, 2,500, Custom",
  Option5 = "250, 500, 1,000, 2,500, 5,000, Custom",
  CustomAll = "All Custom",
}
export enum DonationType {
  OneTime = "One Time Only",
  OneTimeOrMonthly = "One Time or Monthly",
}
export enum UpsertDonationActiveStep {
  Detail = "Detail",
  Pricing = "Pricing",
  Options = "Options",
}
